import { Stack, Typography } from '@mui/material';
import { SelectFilter } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props<T> {
  suppliers: T[];
  selectedSupplier: number | null;
  isLoading?: boolean;
  isError?: boolean;
  getSupplierId: (supplier: T) => number;
  getSupplierName: (supplier: T) => string;
  selectSupplier: (supplierId: number | null) => void;
  hideSupplierId?: boolean;
}

export function SelectSupplier<T>({
  suppliers,
  selectedSupplier,
  isLoading,
  isError,
  getSupplierId,
  getSupplierName,
  selectSupplier,
  hideSupplierId = false,
}: Props<T>) {
  const t = useProductsTFunction();

  return (
    <SelectFilter
      label={t('products.supplier.name')}
      placeholder={t('products.supplier.searchForSuppliers')}
      options={suppliers}
      value={suppliers.find((supplier) => getSupplierId(supplier) === selectedSupplier) ?? null}
      onChange={(supplier) => selectSupplier(supplier ? getSupplierId(supplier) : null)}
      getOptionKey={getSupplierId}
      getOptionLabel={(supplier) => `${getSupplierName(supplier)} ${getSupplierId(supplier)}`}
      renderOptionContent={(supplier) => (
        <Stack>
          <Typography variant="body2">{getSupplierName(supplier)}</Typography>
          {!hideSupplierId && (
            <Typography variant="caption" component="p">
              {getSupplierId(supplier)}
            </Typography>
          )}
        </Stack>
      )}
      disabled={isLoading}
      isLoading={isLoading}
      isError={isError}
      errorMessage={t('products.errors.errorLoadingSuppliers')}
    />
  );
}
